import SEO from "@/components/SEO";
import CtaBanner from "@/components/CtaBanner";
import FaqAccordion, { FAQ_LIST } from "@/components/FaqAccordion";
import { faqSchema } from "@/data/schema";

export default function Faq() {
  return (
    <>
      <SEO
        title="FAQ — Frequently Asked Questions"
        description="Frequently asked questions about Orina Enterprise — seller onboarding, marketplace management, account suspensions, pricing, documents and more."
        path="/faq"
        schema={faqSchema(FAQ_LIST)}
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]}
      />

      <section className="border-b-2 border-black bg-[#FFD700] py-20 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <div className="tape-dark">FAQ</div>
          <h1 className="display mt-6 max-w-4xl text-5xl font-black leading-[0.95] tracking-tight md:text-6xl lg:text-7xl">
            Questions, answered.
          </h1>
          <p className="mt-6 max-w-2xl text-base text-black/80 md:text-lg">
            Quick answers to what we get asked the most. Can't find your question? Hit the WhatsApp button — we reply fast.
          </p>
        </div>
      </section>

      <section className="bg-[#FAFAF7] py-16 md:py-20">
        <div className="mx-auto max-w-3xl px-4 md:px-8">
          <FaqAccordion />
        </div>
      </section>

      <CtaBanner
        title="Still got questions?"
        subtitle="Talk to a real human — no bots, no sales scripts. Free 30-minute consultation."
      />
    </>
  );
}
